import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ApiService } from './services/api.service';
import { SocketService } from './services/socket.service';
import { PushNotificationService } from './services/push-notification.service';
import { NotificationService } from './services/notification.service';

const NOTIFICATION_ID_REGEX = /^[0-9a-fA-F]{24}$/;

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {
  title = 'Dashboard - Equinoccial Adventure - Los Gatitos';

  constructor(private apiServ: ApiService, private socketServ: SocketService, private pushNotificationServ: PushNotificationService, private notificationServ: NotificationService, private router: Router) {
    this.initData();
    this.listenServiceWorkerMessages();
  }

  // Mensajes del Service Worker (custom-service-worker.js) cuando llega o se pulsa un Push de una
  // notificación persistente. El contador lo sigue gestionando NotificationService y la apertura de la
  // notificación sigue siendo responsabilidad de /notification-redirect/:id.
  private onServiceWorkerMessage = (event: MessageEvent) => {
    if (event.origin && event.origin !== window.location.origin) return;
    const message = event.data;
    switch (message?.type) {
      case 'notification-received':
        if (this.apiServ.doGetToken()) this.notificationServ.refreshUnreadCount();
        break;
      case 'notification-click':
        if (typeof message.notificationId === 'string' && NOTIFICATION_ID_REGEX.test(message.notificationId)) {
          this.router.navigate(['/notification-redirect', message.notificationId]);
        }
        break;
      default:
        break; // mensajes desconocidos: se ignoran
    }
  };

  private listenServiceWorkerMessages() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.addEventListener('message', this.onServiceWorkerMessage);
    navigator.serviceWorker.startMessages?.();
  }

  ngOnDestroy() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.removeEventListener('message', this.onServiceWorkerMessage);
  }
  initData() {
    this.apiServ.token.subscribe(async token => { 
      if(!token){
        if(this.apiServ.doGetToken()){
          this.apiServ.setToken(this.apiServ.doGetToken())
          this.apiServ.doGetUserStorage()
          this.apiServ.user$.subscribe(user => { this.pushNotificationServ.subscribeToNotifications(user); })
        }
      }
     })
  }
}
